const PRESETS = [
  {
    label: "Original",
    values: {
      greyscale: 0,
      blur: 0,
      sepia: 0,
      saturate: 100,
      opacity: 100,
      brightness: 100,
      contrast: 100,
      hue: 0,
      invert: 0,
    },
  },
  {
    label: "Grayscale",
    values: {
      greyscale: 100,
      blur: 0,
      sepia: 0,
      saturate: 100,
      opacity: 100,
      brightness: 100,
      contrast: 100,
      hue: 0,
      invert: 0,
    },
  },
  {
    label: "Sepia",
    values: {
      greyscale: 0,
      blur: 0,
      sepia: 100,
      saturate: 100,
      opacity: 100,
      brightness: 100,
      contrast: 100,
      hue: 0,
      invert: 0,
    },
  },
  {
    label: "Vivid",
    values: {
      greyscale: 0,
      blur: 0,
      sepia: 0,
      saturate: 180,
      opacity: 100,
      brightness: 110,
      contrast: 120,
      hue: 0,
      invert: 0,
    },
  },
  {
    label: "Cool",
    values: {
      greyscale: 0,
      blur: 0,
      sepia: 0,
      saturate: 90,
      opacity: 100,
      brightness: 100,
      contrast: 100,
      hue: 200,
      invert: 0,
    },
  },
  {
    label: "Invert",
    values: {
      greyscale: 0,
      blur: 0,
      sepia: 0,
      saturate: 100,
      opacity: 100,
      brightness: 100,
      contrast: 100,
      hue: 0,
      invert: 100,
    },
  },
];
export default PRESETS;
